import React from 'react';
import { RouteList } from '@zg-rentals/route-list';

const FrontPage = () => {
  return (
    <div className="FrontPage Container">
      <h1>Front page of Zillow Rentals Growth</h1>
      {__DEV__ && <RouteList />}
    </div>
  );
};
export default FrontPage;
